module.exports = __webpack_public_path__ + "static/media/becoming-tutor-img1.b0d60f65.jpg";